import React from "react";
import { useLocation } from "react-router-dom";


const SearchResultsPage = () => {
  const location = useLocation();
  const { searchQuery, files } = location.state || {};

  return (
    <div className="outerhomecontainer">
    <h1>Search Results</h1>
    <h2>Search Query: {searchQuery}</h2>
    <div className="fileshome-container">
      {files && files.length > 0 ? (
        files.map((file, index) => (
          <div className="homecontainer" key={index}>
            <div className="innerhomecontainer">
              {file.fileType === "image" ? (
                <img src={file.url} alt={file.filename} />
              ) : file.fileType === "video" ? (
                <video controls>
                  <source src={file.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.filename}
                </a>
              )}
            </div>
            <p>{file.filename}</p>
          </div>
        ))
      ) : (
        <p>No files found</p>
      )}
    </div>
  </div>
  
  );
};

export default SearchResultsPage;
